<template lang="pug">
  .font-draggable(:class="color" @mouseover="handleMouseOver")
    .drag-container(v-if="renderDraggabble")
      vue-draggable-resizable.drag-item(
        :w="406"
        :h="406"
        :parent="true"
        v-for="l in letters"
        :x="positions[l].x"
        :y="positions[l].y"
      )
        .letter(:class="positions[l].color")
          img(:src="getAnimationSources(l)" @click="handleClick(l)" :ref="l")
    .anim-container
      img(:src="'/static/animations/a_6.gif'")
      img(:src="'/static/animations/a_7.gif'")
      img(:src="'/static/animations/a_5.gif'")
    // .letter(ref="letter")
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";
import { mapActions } from "vuex"
import utils from '@/mixins/utils.js'
import lottie from 'lottie-web';

export default {
  name: "FontDraggable",

  components: {
    VueDraggableResizable
  },

  mixins: [utils],

  props: ["color"],

  data() {
    return {
      letters: ["a_1", "a_2", "a_3", "a_4", "a_5", "a_6", "a_7"],
      height: 0,
      width: 0,
      renderDraggabble: false,
      positions: {},
      animationSpeed: 1,
      anim: false
    };
  },

  methods: {
    ...mapActions({
      setCircleVisibility: 'setCircleVisibility'
    }),

    initLottie() {
      for (var i = 0; i < this.letters.length; i++) {
        console.log('/animations/' + i + '.json')
        lottie.loadAnimation({
          container: this.$refs[this.letters[i]][0],
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: '/animations/' + i + '.json'
        });
      }
    },

    createPositions() {
      this.positions = {
        a_1: {
          x: this.width * 0.0125,
          y: 180,
          color: 'b'
        },
        a_2: {
          x: this.width * 0.15,
          y: 280,
          color: 'w'
        },
        a_3: {
          x: this.width * 0.4,
          y: 350,
          color: 'b'
        },
        a_6: {
          x: this.width * 0.23,
          y: 410,
          color: 'b'
        },
        a_5: {
          x: this.width * 0.4486,
          y: 100,
          color: 'b'
        },
        a_4: {
          x: this.width * 0.5972,
          y: 260,
          color: 'b'
        },
        a_7: {
          x: this.width * 0.6458,
          y: 520,
          color: 'w'
        }
      }
    },

    getAnimationSources(l) {
      if (l !== 'a_6' && l !== 'a_7') {
        return '/static/animations/' + l + '.jpg'
      } else {
        return '/static/animations/' + l + '.gif'
      }
    },

    handleMouseOver() {
      this.setCircleVisibility(false)
    },

    handleClick(l) {
      this.$refs[l][0].setAttribute('src', '/static/animations/' + l + '.gif')
    }
  },

  mounted() {
    this.height = window.innerHeight
    this.width = window.innerWidth
    this.createPositions()
    this.renderDraggabble = true
    // setTimeout(() => { this.initLottie() }, 200)
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.font-draggable
  width: 100vw
  cursor: none
  @media only screen and (min-width: $m)
    height: 120vh
  .drag-container
    height: 120vh
    width: 100%
    position: relative
    display: none
    @media only screen and (min-width: $m)
      display: block
    .drag-item
      cursor: none
      &.active
        z-index: 99 !important
    .letter
      color: black
      width: 40rem
      height: 40rem
      display: flex
      justify-content: center
      align-items: center
      background-color: #FFF
      &.w
        border: 3px solid #000
      &.b
        border: 3px solid #FFF
      &.a
        top: 5vw
        left: 7vw
      &.t
        top: 10vw
        left: 12vw
      &.k
        top: 15vw
        left: 17vw
      &.r
        top: 7vw
        left: 55vw
      &.l
        top: 12vw
        left: 58vw
      &.o
        top: 14vw
        left: 62vw
      img
        width: 100%
  .anim-container
    display: block
    width: 100vw
    img
      width: 100%
    @media only screen and (min-width: $m)
      display: none
  .letter
    width: 100%
    height: 100%
</style>
